// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-3eee4e48]{min-height:16em}.menu-icon[data-v-3eee4e48]{text-align:center}.menu-icon.glamping[data-v-3eee4e48]{display:flex;flex-direction:column;max-height:none;width:auto}.menu-icon.glamping[data-v-3eee4e48] img~img{margin-left:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
